//NOTE autogenerated by export script
export {AccountService as Account} from './account.service'
export {AnimalsService as Animals} from './animals.service'
export {CamerasService as Cameras} from './cameras.service'
export {CollarsService as Collars} from './collars.service'
export {ConfigurationDevicesService as ConfigurationDevices} from './configurationDevices.service'
export {DataLoggersService as DataLoggers} from './dataLoggers.service'
export {DropOffsService as DropOffs} from './dropOffs.service'
export {ExternalSensorsService as ExternalSensors} from './externalSensors.service'
export {TT4SensorsService as TT4Sensors} from './tT4Sensors.service'
export {TrapsService as Traps} from './traps.service'
export {BASE_PATH} from '../variables'
export {ApiModule} from '../api.module'
export {ItemsServices as Items} from './itemsService'
export {AllServices as All} from './allService'